import { TRESPONSE_KNOWLEDGE_BASE_QUESTION } from '@monorepo/types';
import { TChatUiModel } from '@monorepo/ui/chat-ui';

export type TChatbotState = {
  chatbotChatUiModel: TChatUiModel<TRESPONSE_KNOWLEDGE_BASE_QUESTION> | null;
};

export const TChatbotActionType = {
  SetChatbotChatUiModel: 'SET_CHATBOT_CHAT_UI_MODEL' as const,
  GetChatbotChatUiModel: 'GET_CHATBOT_CHAT_UI_MODEL' as const,
};

export const MAX_QUERIES_ALLOWED_IN_CHATBOT_CHAT = 15;
export const START_NEW_CONVERSATION_CONFIRMATION_TEXT = {
  LIMIT_REACHED: {
    header: 'Conversation Limit Reached!',
    content: ['To continue, please start a new chat', 'This will clear the current conversation and start a new chat'],
  },
  USER_ACTION: {
    header: 'Start New Chat?',
    content: ['This will clear the current conversation and start a new chat.'],
  },
};

export const CHATBOT_QUICK_QUESTIONS = [
  'How to log a machine breakdown?',
  'How to raise a maintenance ticket?',
  'What is a Location Code?',
  'How to scan a QR code in the Maintaini8 app?',
  'Can I use Maintaini8 in my local language?',
  'How to track downtime and repair status?',
  'How to check ticket resolution time?',
  'How to filter machines based on location?',
  "How to check Machine's repair history?",
];
